import NitroCard from './NitroCard';

export default NitroCard;



// WEBPACK FOOTER //
// ./src/features/fbt/driver/components/NitroCard/index.js